import { BTIconFormOutlined } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemEditOnlineProps {
    fileId: number;
    onClick: () => Promise<void>;
}

const MenuItemEditOnline = ({ fileId, onClick, ...antProps }: IMenuItemEditOnlineProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`editOnline-menuitem-${fileId}`}
            testid={`editOnline-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconFormOutlined /> Edit online
        </BTMenu.Item>
    );
};

export default MenuItemEditOnline;
